export const CERTIFICATES_GENERATE_TOKEN = 'CERTIFICATES_GENERATE_TOKEN';
export const CERTIFICATES_GENERATE_TOKEN_RESULT = 'CERTIFICATES_GENERATE_TOKEN_RESULT';
export const CERTIFICATES_DOWNLOAD = 'CERTIFICATES_DOWNLOAD';
export const CERTIFICATES_DOWNLOAD_RESULT = 'CERTIFICATES_DOWNLOAD_RESULT';
export const CERTIFICATES_SET_LOADING = 'CERTIFICATES_SET_LOADING';